import InternalTransferForm from '@withdrawals/views/InternalTransferForm'

const InternalTransfer = () => <InternalTransferForm useSubAccounts={false} />
export default InternalTransfer
